/**
 * Ortak navbar görünümü (Tema 1 / Tema 2 tarafından genişletilir).
 * Stil kaynağı AdminNavbar.js değil; tema appearance modülleri + bu dosya.
 */

export const adminNavbarAppearanceShared = {
  /** Üst çubuktaki marka görseli (<img>); Tema 2’de kapalı */
  showNavbarLogoImage: true,
  /** Üst çubuktaki marka yazısı (<NavbarBrand>); Tema 2’de sidebar’da gösterilir */
  showNavbarBrandText: true,
  /** Desktop search çubuğunun içindeki "Enter" rozeti (Tema 2'de kapatılabilir) */
  showSearchEnterBadge: true,
  /**
   * "overlay" — hamburger `toggleSidebar` (nav-open, mobil benzeri tam aç/kapa).
   * "mini" — hamburger `handleMiniClick` (sidebar içi daralt/genişlet ile aynı).
   */
  sidebarTriggerAction: "overlay",
  /** Koyu üst çubuk (şeffaf / #2F3742) — açık logo */
  logoImg: {
    filter: "invert(1) brightness(2)",
    height: "30px",
    cursor: "pointer",
  },
  /** Açık üst çubuk (Tema 1 mobil collapse bg-white, Tema 2 white-content) — koyu logo */
  logoImgLightSurface: {
    filter: "brightness(0) saturate(100%)",
    height: "30px",
    cursor: "pointer",
  },
  brand: {
    fontFamily: "Helvetica Neue, Helvetica, Arial, sans-serif",
    fontSize: "1rem",
    fontWeight: "inherit",
    cursor: "pointer",
  },
  centerNav: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    padding: "0 20px",
  },
  /** Desktop arama satırı Bootstrap ek sınıfları (`mx-auto` = ortada; Tema 2 sola hizalı + `flex-grow-1`) */
  desktopSearchNavExtraClassName: "mx-auto",
  searchTriggerFrame: {
    display: "flex",
    alignItems: "center",
    backgroundColor: "rgba(100, 100, 100, 0.2)",
    width: "100%",
    cursor: "pointer",
    border: "1px solid rgba(255, 255, 255, 0.2)",
    transition: "background-color 0.2s ease",
  },
  searchTriggerHoverBg: "rgba(100, 100, 100, 0.4)",
  searchTriggerDefaultBg: "rgba(100, 100, 100, 0.2)",
  searchIcon: {
    color: "rgba(255,255,255,0.7)",
    marginRight: "10px",
  },
  searchPlaceholder: {
    color: "rgba(255,255,255,0.7)",
    fontSize: "14px",
    flex: 1,
    userSelect: "none",
  },
  searchEnterWrap: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },
  searchEnterBadge: {
    backgroundColor: "rgba(255, 255, 255, 0.2)",
    padding: "2px 8px",
    fontSize: "11px",
    fontWeight: "bold",
    color: "rgba(255,255,255,0.7)",
    border: "none",
  },
  rightNav: {
    justifyContent: "center",
    alignItems: "center",
  },
  rightNavItemWrap: {
    justifyContent: "center",
    alignItems: "center",
    marginLeft: "0.5vh",
    marginRight: "0.5vh",
  },
  accountMenuWrap: {
    height: "10%",
    justifyContent: "space-between",
    alignItems: "center",
    marginLeft: "0.5vh",
  },
  mobileToolsRow: {
    gap: "15px",
  },
  modalRoot: {
    width: "33.5%",
    maxWidth: "1500px",
  },
  modalHeader: {
    alignItems: "center",
  },
  modalSearchRow: {
    display: "flex",
    alignItems: "center",
    flex: 1,
  },
  modalSearchIcon: {
    marginRight: "10px",
    color: "#6c757d",
  },
  modalInput: {
    border: "none",
    outline: "none",
    fontSize: "18px",
    height: "25px",
    flex: 1,
  },
  modalBody: {
    padding: "0",
    maxHeight: "400px",
    overflowY: "auto",
  },
  sectionHeader: {
    padding: "8px 16px",
    color: "#8898aa",
    fontSize: "11px",
    textTransform: "uppercase",
    fontWeight: 600,
    backgroundColor: "#f8f9fa",
  },
  resultRow: {
    border: "none",
    borderBottom: "1px solid #f8f9fa",
    cursor: "pointer",
    padding: "8px 16px",
    transition: "background-color 0.2s",
  },
  resultRowHoverBg: "#f8f9fa",
  resultRowDefaultBg: "transparent",
  resultRowInner: {
    display: "flex",
    alignItems: "center",
  },
  resultIconWrapBase: {
    width: "30px",
    height: "30px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: "12px",
    fontSize: "13px",
    color: "white",
    flexShrink: 0,
  },
  resultIconFont: {
    fontSize: "15px",
  },
  resultTextCol: {
    flex: 1,
    minWidth: 0,
  },
  resultTitle: {
    fontWeight: "600",
    color: "#32325d",
    fontSize: "13px",
    marginBottom: "1px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  resultPath: {
    color: "#8898aa",
    fontSize: "10.5px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  resultMetaCol: {
    textAlign: "right",
    minWidth: "80px",
    marginLeft: "10px",
  },
  resultCategory: {
    fontSize: "8.5px",
    textTransform: "uppercase",
    fontWeight: "700",
    opacity: 0.6,
    letterSpacing: "0.3px",
  },
  resultStatus: {
    fontSize: "9.5px",
    textTransform: "uppercase",
    fontWeight: "800",
    marginTop: "1px",
  },
  emptyState: {
    textAlign: "center",
    padding: "10px",
    color: "#6c757d",
  },
  emptyStateIcon: {
    fontSize: "24px",
    marginBottom: "8px",
  },
  emptyStateHint: {
    fontSize: "12px",
    marginTop: "4px",
  },
};
